var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurvedArrowQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 118,
    viewBox: "0 0 81 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07815 0.694336C0.525868 0.69432 0.0781406 1.14202 0.078125 1.69431C0.0781095 2.24659 0.525812 2.69432 1.0781 2.69434L1.07812 1.69434L1.07815 0.694336ZM70.2231 116.762C70.4805 117.25 71.0852 117.438 71.5739 117.181L79.5373 112.987C80.026 112.73 80.2135 112.125 79.9562 111.637C79.6989 111.148 79.0941 110.96 78.6055 111.218L71.5269 114.945L67.7994 107.866C67.5421 107.378 66.9374 107.19 66.4487 107.448C65.96 107.705 65.7725 108.31 66.0298 108.798L70.2231 116.762ZM1.07812 1.69434L1.0781 2.69434C26.8152 2.69506 50.7785 9.30442 64.9556 26.6063C79.1048 43.8741 83.7622 72.1157 70.1528 116L71.108 116.296L72.0631 116.592C85.7635 72.4143 81.2658 43.3558 66.5026 25.3387C51.7673 7.35562 27.0608 0.695068 1.07815 0.694336L1.07812 1.69434Z",
    fill: "#4C4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrowQr);
export default __webpack_public_path__ + "static/media/curved-arrow-qr.43b9a6eae311180f9520c4b9a32ebcc6.svg";
export { ForwardRef as ReactComponent };